import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [resetToken, setResetToken] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.reset_token) setResetToken(data.reset_token);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md rounded-lg border tf-hairline bg-white p-8">
          <h1 className="font-[Chivo] text-3xl font-black text-[#0A2540]">Reset your password</h1>
          <p className="text-slate-600 mt-2">Enter your email — we'll send you a secure reset link.</p>
          {sent ? (
            <div className="mt-6 rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm">
              <div className="font-semibold text-emerald-800">If an account exists, a reset link was sent.</div>
              {resetToken && (
                <div className="mt-3 text-slate-700">
                  <div className="text-xs font-mono uppercase tracking-widest text-slate-500 mb-1">Dev preview token</div>
                  <div className="font-mono text-xs break-all bg-white rounded p-2 border tf-hairline" data-testid="reset-token-display">{resetToken}</div>
                  <Link to={`/reset-password?token=${resetToken}`} className="mt-3 inline-block text-[#D32F2F] font-semibold" data-testid="use-reset-link">Continue with this token →</Link>
                </div>
              )}
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="forgot-email" />
              </div>
              {error && <div className="text-sm text-[#D32F2F] bg-[#D32F2F]/10 rounded px-3 py-2">{error}</div>}
              <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0A2540]" data-testid="forgot-submit">{loading ? "Sending…" : "Send reset link"}</Button>
            </form>
          )}
          <div className="mt-6 text-sm text-slate-600">
            Remembered it? <Link to="/auth?tab=login" className="text-[#0A2540] font-semibold">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
